var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
import { EMAIL_PATTERN } from "../../utils/constants.js";

module.exports = Model({
	name: "finishaccount",
	init: init,
	listeners,
	triggers,
	_fname: "",
	_lname: "",
	_hasParent: null,
	_hasLicenseChecked: false,
	_hasPrivacyPolicyChecked: false,
});

function init() {
	AsyncStorage.getItem("parent").then(parent => {
		this._hasParent = !!parent;
	});
	this.push({
		open: false,
		error: null
	});
}

function listeners() {
	return {
		"personal:updated": finish_account
	};
}

function reset() {
	this._fname = "";
	this._lname = "";
	this.push({
		open: false,
		error: null
	});
}

function triggers() {
	return {
		"submit": handle_finish_account,
		"checked": handle_checked
	};
}

function handle_finish_account(data) {
	var email = data.email;
	var password = data.password;
	var password_confirm = data.password_confirm;

	var errors = [];

	if (!email)
		errors.push({ field: ["email"], message: "passworderrors.required" });

	if (!password)
		errors.push({ field: ["password"], message: "passworderrors.required" });

	if (!password_confirm)
		errors.push({ field: ["password_confirm"], message: "passworderrors.required" });


	if (!this._hasLicenseChecked)
		errors.push({ field: ["iAcceptAetonixLicense"], message: "schedule.schedulenolicense" });

	if (!this._hasPrivacyPolicyChecked)
		errors.push({ field: ["iAcceptUserPolicy"], message: "privacy_policy.schedulenouserpolicy" });

	if (errors.length)
		return this.extend({
			error: errors
		});

	if (email && !email.match(EMAIL_PATTERN))
		errors.push({ field: ["email"], message: "register.emailpattern" });

	var emailArr = email.split("@");
	var emailStr = emailArr[0];
	if (password.includes(this._fname) || password.includes(this._lname) || password.includes(emailStr))
		errors.push({ field: ["password"], message: "myprofile.invalidnameinclusion" });

	if (errors.length)
		return this.extend({
			error: errors
		});

	this.api.auth.finishaccount(email, password, password_confirm)
		.then(reset.bind(this))
		.catch(failedfinishaccount.bind(this));

	this.emit("usermetrics:trigger:track", "create account");
}

/**
 * This gets caleld when registration fails
 * @param  {Error} error The error that occured
 */
function failedfinishaccount(error) {
	var response = error.response;
	var status = error.status;
	var error_map = {
		402: "register.accounttaken",
		500: "register.registerfaild",
		undefined: "register.error0"
	};

	var errors = [];

	if (status === 400) {
		if (response.message === "Password must not include 2 sequential characters from keyboard") {
			errors.push({ field: ["password"], message: "myprofile.invalidsequential" });
		} else if (response.message === "Password must not include 3 consecutive characters") {
			errors.push({ field: ["password"], message: "myprofile.invalidconescutive" });
		} else if (response.message === "Password does not match basic rules") {
			errors.push({ field: ["password"], message: "myprofile.invalidbasicrules" });
		} else if (response.message === "Pasword confirm doesn't match") {
			errors.push({ field: ["password_confirm"], message: "register.passwordmismatch" });
		}
	} else {
		errors.push({ field: ["email"], message: error_map[status] });
	}

	this.extend({
		error: errors
	});
}

function finish_account(data) {
	this._fname = data.fname;
	this._lname = data.lname;
	var open = false;

	var type = data.type || [];
	const mobileUser = (type.indexOf("user:mobile") !== -1);
	const noneLogin = (type.indexOf("login:none") !== -1);

	if (mobileUser && !this._hasParent && (!data.email || noneLogin))
		open = true;

	this.extend({
		open: open
	});
}

function handle_checked(data) {

	if (data.iAcceptAetonixLicense !== undefined) {
		this._hasLicenseChecked = data.iAcceptAetonixLicense;
	}
	if (data.iAcceptUserPolicy !== undefined) {
		this._hasPrivacyPolicyChecked = data.iAcceptUserPolicy;
	}

	this.emit("usermetrics:trigger:track", "finish account checked", {
		iAcceptAetonixLicense: this._hasLicenseChecked,
		iAcceptUserPolicy: this._hasPrivacyPolicyChecked
	});
}